export function Bubble(item, isMultiple, onClick) {
    this.item = item;

    this.elem = function () {
        const bubble = document.createElement('div');
        bubble.innerText = this.item.label;
        if (isMultiple) {
            bubble.className = 'search-bubble';
            (function (item) {
                bubble.addEventListener('click', function (evt) {
                    evt.stopPropagation();
                    onClick(item);
                });
            })(this.item);
        } else {
            bubble.className = 'search-bubble single';
        }

        return bubble;
    }
}